import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import styles from "./select.module.scss";
import { forwardRef } from "react";
import { FormHelperText, SxProps, Theme } from "@mui/material";

export interface ISelectOption {
  value?: any;
  label?: any;
  img?: any;
  disabled?: boolean;
}

export interface ISelect {
  value?: any;
  label?: any;
  defaultValue?: any;
  options?: Array<ISelectOption>;
  onChange?: any;
  onBlur?: any;
  disabled?: boolean;
  displayEmpty?: boolean;
  required?: any;
  helperText?: any;
  error?: any;
  shrink?: any;
  inputProps?: any;
  isFilter?: boolean;
  id?: string;
  labelId?: string;
  // JIRA: [EVES-4137] -charger editor and properties
  // Author: Anitha
  // Date: 19/01/2026
  sx?: SxProps<Theme>;
  renderValue?: (value: any) => React.ReactNode;
  SelectDisplayProps?: Record<string, unknown>;
}

// eslint-disable-next-line react/display-name
const EvesSelect = forwardRef((props: ISelect, ref: any) => {
  const {
    value,
    label,
    defaultValue,
    options,
    onChange,
    disabled,
    displayEmpty,
    required,
    helperText,
    error,
    shrink,
    inputProps,
    isFilter,
    id,
    labelId: labelIdProp,
    sx,
    renderValue,
    ...selectPassthrough
  } = props;

  const labelId = labelIdProp ?? `${label}SelectInputLabel`;
  const selectId = id ?? `${label}Select`;

  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        error={error}
        className={`${styles.select} ${isFilter ? styles.selectFilter : ""}`}
      >
        <InputLabel id={labelId} shrink={shrink}>
          {label}
        </InputLabel>
        <Select
          defaultValue={defaultValue}
          labelId={labelId}
          id={selectId}
          required={required}
          error={error}
          onChange={onChange}
          disabled={disabled}
          ref={ref}
          value={value}
          sx={sx}
          displayEmpty={displayEmpty}
          inputProps={inputProps}
          renderValue={renderValue}
          {...selectPassthrough}
        >
          {options?.map((item: ISelectOption, index: number) => (
            <MenuItem
              className={styles.selectItem}
              key={index}
              value={item.value}
              disabled={item?.disabled}
              data-cy={isFilter ? "dropdown-list-item" : undefined}
            >
              {item.img ? (
                <span className={styles.selectItemImg}>
                  <img alt="All Connectors" src={item.img} />
                </span>
              ) : null}
              <span className={styles.selectItemLabel}>{item.label}</span>
            </MenuItem>
          ))}
        </Select>
        {error && helperText != null && helperText !== "" && (
          <FormHelperText error>
            <span style={{ color: "red" }}>{helperText}</span>
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
});

export default EvesSelect;
